<template>
  <section class='viewsrhqy_Oplog p-4 space-y-4'>
    <viewTitle title="业务管理 / 操作日志"></viewTitle>
    <el-form :inline="true" class="search-form-inline">
      <el-form-item label="操作时间">
        <el-date-picker class="!w-96" style="margin-bottom: 10px;" v-model="timeRange" type="datetimerange"
                        align="right" unlink-panels range-separator="至" :default-time="['00:00:00', '23:59:59']"
                        start-placeholder="开始时间" end-placeholder="结束时间" :picker-options="pickerOptions"
                        value-format="timestamp"></el-date-picker>
      </el-form-item>
      <el-form-item label="操作账号">
        <el-input
            clearable
            v-model="queryParam.account"
            placeholder="请输入操作账号"
            class="w-60"
        ></el-input>
      </el-form-item>
      <el-form-item label="功能模块">
        <el-input
            clearable
            v-model="queryParam.operate"
            placeholder="请输入功能模块"
            class="w-60"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="refreshData" size="small"
        >刷新数据
        </el-button
        >
        <el-button @click="onReset" size="small">重置</el-button>
      </el-form-item>
    </el-form>
    <c-table
        class="mt-4"
        :data="dataSource"
        :columns="columns"
        :query.sync="pagintion"
        :total="total"
        @loadPage="loadData"
    >
      <template slot="create_time" slot-scope="{row}">
        {{ row.create_time | timeFormat }}
      </template>
    </c-table>
  </section>
</template>

<script>
import initListMinxin from "@/mixins/jl/initListMinxin";

export default {
  data() {
    return {
      columns: [
        {width: 200, label: "操作时间", prop: "create_time"},
        {width: 200, label: "角色", prop: "role_name"},
        {width: 120, label: "操作账号", prop: "account"},
        {width: 200, label: "功能模块", prop: "operate"},
        {width: 100, label: "操作状态", prop: "result_type", formatData: row => row.result_type == 1 ? '成功' : '失败'},
        {label: "操作内容", prop: "detail"},
      ],
      fetchDataEvent: params => {
        return this.$common.http({
          url: "/api/queue/admin/query_user_log",
          data: params
        });
      },
      disabledCreated: true
    };
  },

  computed: {},

  watch: {},

  components: {},

  mixins: [initListMinxin],

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },


  activated() {
  },

  deactivated() {
  },


  methods: {},

}

</script>
<style lang='less' scoped>
.viewsrhqy_Oplog {
}
</style>
<style lang='less'>
.viewsrhqy_Oplog {
}
</style>